// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://barem-dezastre.herokuapp.com',
  firebase: {
    apiKey: 'AIzaSyAhiCV3XyGu1V3J91zNNTyhe75-ZrRoaPo',
    authDomain: 'detasament-8f226.firebaseapp.com',
    databaseURL: 'https://detasament-8f226.firebaseio.com',
    projectId: 'detasament-8f226',
    storageBucket: 'detasament-8f226.appspot.com',
    messagingSenderId: '964767019490',
    appId: '1:964767019490:web:9c47ad1766c690b6b9c9bb',
    measurementId: 'G-YYHP0HQTDF'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
